<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
          تغییر قیمت دسته جمعی
        </span>
      </h1>
      <div class="flex flex-wrap gap-3 mr-3">
        <button type="button" @click="openProfitIncrease" class="px-4 py-2 bg-emerald-600 text-white text-sm rounded-lg shadow-sm hover:bg-emerald-700">افزایش نرخ سود</button>
        <button
            @click="goToExcelUpdate"
            class="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-600 text-white text-sm rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
        >
          بروزرسانی قیمت با اکسل
        </button>
        <button
            @click="refreshProducts"
            class="p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 mb-6 shadow-sm border border-gray-100 flex items-center justify-between gap-4">

      <div class="flex w-full items-center gap-2 ml-auto">
        <select
            @change="applyFilters"
            :disabled="priceChangeBusy"
            v-model="filters.currency_in"
            class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right"
        >
          <option :value="null">همه ارزها</option>
          <option
              v-for="currency in currencies"
              :key="currency.id"
              :value="currency.id"
          >
            {{ currency.name }}
          </option>
          <option value="null">بدون ارز</option>
        </select>

        <select
            @change="applyFilters"
            :disabled="priceChangeBusy"
            v-model="filters.brand_in"
            class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right"
        >
          <option :value="null">همه برندها</option>
          <option
              v-for="brand in brands"
              :key="brand.id"
              :value="brand.id"
          >
            {{ brand.name }}
          </option>
        </select>

        <select
            @change="applyFilters"
            :disabled="priceChangeBusy"
            v-model="filters.category_in"
            class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right"
        >
          <option :value="null">همه دسته‌ها</option>
          <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
          >
            {{ category.name }}
          </option>
        </select>

        <button
            @click="resetFilters"
            :disabled="priceChangeBusy"
            class="px-3 py-2 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-lg shadow hover:shadow-md transition-all duration-300 transform hover:scale-105"
            title="حذف فیلترها"
        >
          حذف فیلترها
        </button>
      </div>
    </div>
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 mb-6 shadow-sm border border-gray-100 flex items-center justify-between gap-4">


      <div class="flex w-full items-center gap-2 left-0 justify-start">
        <select
            :disabled="priceChangeBusy || (!filters.brand_in && !filters.category_in && !filters.currency_in)"
            v-model="regularPercentType"
            class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right disabled:bg-gray-200 disabled:text-gray-500"
        >
          <option value="">نوع تغییر</option>
          <option value="افزایش"> افزایش </option>
          <option value="کاهش"> کاهش</option>
        </select>

        <div class="relative">
          <span class="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm">%</span>
          <input
              type="number"
              v-model.number="changeRegularPercent"
              min="0"
              max="100"
              :placeholder="`درصد ${regularPercentType} `"
              :disabled="priceChangeBusy || (!filters.brand_in && !filters.category_in && !filters.currency_in) || !regularPercentType"
              class="pl-6 pr-3 py-2 w-32 text-sm rounded-lg border bg-gray-100 text-right disabled:bg-gray-200"
          />
        </div>
        <button
            @click="applyRegularChange"
            :disabled="!canChangeBasePrice"
            :class="[
        'px-4 py-2 text-xs rounded-lg shadow hover:shadow-md transition-all duration-300 transform',
        !canChangeBasePrice
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-gradient-to-r from-blue-500 to-green-500 text-white'
      ]"
        >
          اعمال در قیمت پایه (خرید)
        </button>
      </div>




      <div class="flex w-full items-center gap-2 left-0 justify-start">
        <select
            :disabled="priceChangeBusy || (!filters.brand_in && !filters.category_in && !filters.currency_in)"
            v-model="percentType"
            class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right disabled:bg-gray-200 disabled:text-gray-500"
        >
          <option value="">نوع تغییر</option>
          <option value="افزایش"> افزایش </option>
          <option value="کاهش"> کاهش</option>
        </select>

        <div class="relative">
          <span class="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm">%</span>
          <input
              type="number"
              v-model.number="changePercent"
              min="0"
              max="100"
              :placeholder="`درصد ${percentType} `"
              :disabled="priceChangeBusy || (!filters.brand_in && !filters.category_in && !filters.currency_in) || !percentType"
              class="pl-6 pr-3 py-2 w-32 text-sm rounded-lg border bg-gray-100 text-right disabled:bg-gray-200"
          />
        </div>
        <button
            @click="applyChange"
            :disabled="!canChangeConsumerPrice"
            :class="[
        'px-4 py-2 text-xs rounded-lg shadow hover:shadow-md transition-all duration-300 transform ',
        !canChangeConsumerPrice
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-gradient-to-r from-blue-500 to-green-500 text-white'
      ]"
        >
          اعمال در قیمت مصرف کننده
        </button>
      </div>

      <div class="flex w-full items-center gap-2 left-0 justify-end">
        <div class="relative">
          <span class="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm">%</span>
          <input
              type="number"
              v-model.number="offerPercent"
              min="0"
              max="100"
              placeholder="درصد تخفیف"
              :disabled="!filters.brand_in && !filters.category_in && !filters.currency_in"
              class="pl-6 pr-3 py-2 w-32 text-sm rounded-lg border bg-gray-100 text-right disabled:bg-gray-200"
          />
        </div>
        <button
            @click="applyDiscount"
            :disabled="(!filters.brand_in && !filters.category_tree && !filters.currency_in) || !offerPercent"
            :class="[
        'px-4 py-2 text-xs rounded-lg shadow hover:shadow-md transition-all duration-300 transform ',
        ((!filters.brand_in && !filters.category_tree && !filters.currency_in) || !offerPercent)
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-gradient-to-r from-blue-500 to-green-500 text-white'
      ]"
        >
          اعمال تخفیف
        </button>
      </div>
    </div>

    <p class="text-sm text-gray-600 mb-3">تغییر قیمت پایه، قیمت فروش را با سود و تخفیف فعلی بازمحاسبه می‌کند. تغییر قیمت مصرف‌کننده، فقط قیمت روی کالا را تغییر می‌دهد. درصد باید مثبت باشد و کاهش کمتر از ۱۰۰٪ باشد.</p>
    <p v-if="priceChangeBusy" role="status" class="text-sm text-blue-700 mb-3">در حال تغییر قیمت‌ها...</p>
    <p v-if="priceChangeError" role="alert" class="text-sm text-red-700 mb-3">{{ priceChangeError }}</p>
    <p v-if="priceChangeResult" role="status" class="text-sm text-green-700 mb-3">{{ priceChangeResult }}</p>
    <!-- Table -->
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">شناسه</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">محصول</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">نوع</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">قیمت پایه (خرید)</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">قیمت مصرف‌کننده</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">قیمت فروش</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">درصد تخفیف</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">موجودی</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">برند</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">نوع ارز</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">وضعیت</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="13" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="products.length === 0">
            <td colspan="13" class="p-4 text-center text-gray-500">
              محصولی یافت نشد
            </td>
          </tr>
          <tr
              v-for="product in products"
              :key="product.id"
              class="border-t border-gray-100 hover:bg-gray-50 transition-colors duration-200"
          >
            <td class="p-3 font-medium text-[9px] text-gray-900">{{ product.id  || ' بدون شناسه'}}</td>
            <td class="p-3 font-medium text-[9px] text-gray-900">{{ product.sixteen_digit_code  || ' بدون کد'}}</td>
            <td class="p-3">
              <div class="flex items-center gap-3">
                <div class="relative" v-if="product.image">
                  <img
                      :src="img_source(product.image)"
                      class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                  >
                </div>
                <div>
                  <div class="text-[9px] font-medium text-gray-900">{{ product.name }}</div>
                  <div class="text-[9px] text-gray-500 text-xs mt-1">{{ product.sixteen_digit_code }}</div>
                  <div class="text-[9px] text-gray-500 text-xs mt-1 flex items-center gap-1"
                       v-if="product.product_type == 'variation'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                    </svg>
                    {{ product.variation_of_name }}
                  </div>
                </div>
              </div>
            </td>
            <td class="p-3">
                <span
                    class="px-2.5 py-1 rounded-full text-[8px] font-medium"
                    :class="{
                    'bg-green-100 text-green-800': product.product_type === 'simple',
                    'bg-blue-100 text-blue-800': product.product_type === 'variable',
                    'bg-red-100 text-red-800': product.product_type === 'variation'
                  }"
                >
                  {{ getTypeLabel(product.product_type) }}
                </span>
            </td>

            <td class="p-3 text-[9px]">
              <template v-if="product.product_type !== 'variable'">{{ product.base_price == null ? '—' : Number(product.base_price).toLocaleString('fa-IR') }} {{ product.currency_name || 'تومان' }}</template>
              <span v-else>روی زیرمحصول‌های فعال اعمال می‌شود</span>
            </td>
            <td class="p-3 text-[9px]">{{ product.product_type === 'variable' || product.regular_price == null ? '—' : Number(product.regular_price).toLocaleString('fa-IR') + ' تومان' }}</td>
            <td class="p-3" v-if="product.product_type != 'variable'">
              <div class="text-[9px] font-medium text-gray-900">{{ product.price | toMoney }} تومان</div>
              <div v-if="product.regular_price > product.price" class="text-[8px] text-green-600 line-through mt-1">
                {{ product.regular_price | toMoney }}
                تومان
              </div>
            </td>
            <td class="p-3 align-center" v-else>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform transition-transform duration-200"
                   fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </td>
            <td class="p-3" v-if="product.product_type != 'variable'">
              <div class="text-[9px] font-medium text-gray-900" v-if="product.regular_price > product.price">
                  <span class="bg-pink-300 text-pink-600 px-2.5 py-1 rounded-full text-[9px] font-medium">
                    {{ product.offer_percentage }}
                  </span>
              </div>
              <div class="text-[9px] font-medium text-gray-900" v-if="product.regular_price == product.price">-</div>
            </td>
            <td class="p-3 text-[9px]" v-if="product.product_type == 'variable'">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform transition-transform duration-200"
                   fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </td>

            <td class="p-3 text-[9px]">
              <div class="flex items-center gap-1"
                   v-if="product.calculate_current_inventory == 0">
                <span class="bg-red-300 text-red-600 px-1.5 py-0.5 rounded-full text-[7px] font-medium">
                   اتمام موجودی
                </span>
              </div>
              <div class="flex items-center gap-1 text-[9px]"
                   v-if="product.calculate_current_inventory > 0">
                {{ product.calculate_current_inventory | toMoney }}
                <span class="text-xs text-gray-500 text-[7px]">عدد</span>
              </div>
            </td>
            <td class="p-3">
              <span class="text-[9px]" v-if="product.brand">{{product.brand.name}}</span>
            </td>
            <td class="p-3 truncate-text">
              <span class="text-[9px] ">{{product.currency_name}}</span>
            </td>

            <td class="p-3">
              <span
                  class="px-1.5 py-0.5 rounded-full text-[8px] font-medium"
                  :class="{
                 'bg-green-100 text-green-800': product.status === 'publish',
                 'bg-yellow-100 text-yellow-800': product.status === 'pending',
                 'bg-gray-100 text-gray-800': product.status === 'draft',
                 'bg-red-100 text-red-800': product.status === 'archived'
               }"
              >
               {{ getStatusLabel(product.status) }}
                </span>

            </td>
            <td>
              <button @click="showProductQuickView(product)"
                      class="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-full transition-colors duration-200"
                      title="مشاهده سریع">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </button>
            </td>

          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
          {{ totalProducts }} محصول
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
              :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalProducts"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalProducts }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <product-quick-view
        v-if="selectedProduct"
        :product="selectedProduct"
        :is-visible="showQuickView"
        @close="showQuickView = false"
        @edit="handleEditProduct(selectedProduct)"
    />
    <v-dialog v-model="showProfitIncrease" max-width="520" :persistent="profitIncreaseBusy">
      <div class="bg-white rounded-xl p-6" dir="rtl">
        <h2 class="text-lg font-bold mb-3">افزایش نرخ سود محصولات یک ارز</h2>
        <p class="text-sm text-gray-600 mb-4 leading-7">افزایش ۱، سود ۳۰٪ را به ۳۱٪ تبدیل می‌کند. محصولات بدون قیمت پایه، محصولات مادر متغیر و محصولاتی که قیمت جدیدشان کمتر می‌شود کنار گذاشته می‌شوند.</p>
        <form @submit.prevent="submitProfitIncrease">
          <label class="block text-sm mb-2">نوع ارز</label>
          <select v-model="profitIncreaseCurrency" @change="changeProfitCurrency" :disabled="profitIncreaseBusy || profitBatches.length > 0" class="w-full rounded-lg border p-3 mb-4">
            <option disabled value="">انتخاب ارز</option>
            <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{ currency.name }}</option>
          </select>
          <label class="block text-sm mb-2">شریک</label>
          <select v-model="profitIncreasePartner" @change="loadProfitPreview" :disabled="profitIncreaseBusy || profitBatches.length > 0" class="w-full rounded-lg border p-3 mb-3">
            <option value="">همه شرکای این ارز (شامل محصولات بدون شریک)</option>
            <option v-for="partner in profitPartners" :key="partner.id" :value="partner.id">{{ partner.name }}</option>
          </select>
          <label class="flex gap-2 text-sm mb-3"><input v-model="profitIncludeAmount" @change="loadProfitPreview" :disabled="profitIncreaseBusy || profitBatches.length > 0" type="checkbox" />محصولات با سود مبلغی هم شامل شوند</label>
          <p v-if="profitIncludeAmount" class="text-xs text-gray-600 mb-3">برای سود مبلغی، همین درصد به مبلغ سود اضافه می‌شود؛ مثلاً ۱٪، سود ۱۰۰٬۰۰۰ تومان را به ۱۰۱٬۰۰۰ تومان می‌رساند.</p>
          <label class="block text-sm mb-2">مقدار افزایش درصد سود</label>
          <input v-model="profitIncreasePoints" @input="scheduleProfitPreview" :disabled="profitIncreaseBusy || profitBatches.length > 0" type="text" inputmode="numeric" placeholder="مثلاً ۱" class="w-full rounded-lg border p-3 mb-3" />
          <p v-if="profitPreviewLoading" class="text-sm text-gray-500 mb-3">در حال دریافت نمونه‌ها...</p>
          <div v-else-if="profitPreview" class="mb-4">
            <p class="text-xs mb-2">{{ profitPreview.product_ids.length }} محصول قابل تغییر؛ {{ profitPreview.skipped_count }} محصول خارج از شرایط کنار گذاشته می‌شود.</p>
            <p class="text-xs mb-2" v-if="profitPreview.skipped_reasons">بدون پایه: {{ profitPreview.skipped_reasons.missing_base || 0 }}؛ کاهش قیمت: {{ profitPreview.skipped_reasons.lower_price || 0 }}؛ سود مبلغی خارج از انتخاب: {{ profitPreview.skipped_reasons.amount_excluded || 0 }}</p>
            <table v-if="profitPreview.samples.length" class="w-full text-xs border">
              <thead class="bg-gray-100"><tr><th class="p-2">محصول</th><th class="p-2">سود فعلی ← جدید</th><th class="p-2">قیمت فعلی ← جدید (تومان)</th></tr></thead>
              <tbody><tr v-for="product in profitPreview.samples" :key="product.id" class="border-t"><td class="p-2">{{ product.name }} (#{{ product.id }})</td><td class="p-2">{{ product.profit_margin }} ← {{ product.new_profit_margin }} {{ product.profit_type === 'percent' ? '٪' : 'تومان' }}</td><td class="p-2">{{ Number(product.price || 0).toLocaleString('fa-IR') }} ← {{ Number(product.new_price).toLocaleString('fa-IR') }}</td></tr></tbody>
            </table>
          </div>
          <div v-if="profitProgress.total" class="mb-4" role="status" aria-live="polite">
            <div class="h-3 rounded-full bg-gray-200 overflow-hidden" role="progressbar" :aria-valuenow="profitProgress.processed" :aria-valuemax="profitProgress.total" aria-valuemin="0" aria-label="پیشرفت افزایش سود">
              <div class="h-full bg-emerald-500 transition-all" :style="{ width: (profitProgress.processed / profitProgress.total * 100) + '%' }"></div>
            </div>
            <p class="text-xs mt-2">{{ Math.round(profitProgress.processed / profitProgress.total * 100) }}٪ — {{ profitProgress.processed }} از {{ profitProgress.total }} محصول؛ تغییر یافته: {{ profitProgress.updated }}</p>
          </div>
          <p v-if="profitIncreaseError" role="alert" class="text-sm text-red-600 mb-3">{{ profitIncreaseError }}</p>
          <p v-if="profitIncreaseResult" role="status" class="text-sm text-green-700 mb-3">{{ profitIncreaseResult }}</p>
          <div class="flex justify-end gap-3 mt-4">
            <button type="button" :disabled="profitIncreaseBusy" @click="showProfitIncrease = false" class="rounded-lg border px-4 py-2">بستن</button>
            <button type="submit" :disabled="profitIncreaseBusy || profitPreviewLoading || !profitPreview || !profitPreview.product_ids.length" class="rounded-lg bg-emerald-600 px-4 py-2 text-white disabled:opacity-50">{{ profitIncreaseBusy ? 'در حال اعمال...' : profitBatches.length ? 'ادامه پردازش' : 'اعمال افزایش روی محصولات این ارز' }}</button>
          </div>
        </form>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ProductQuickView from "@/modules/product_admin/QuickViewModal";
import AdminProductForm from "@/modules/product_admin/AdminProductForm";
export default {
  name: 'AdminProductList',
  components: {ProductQuickView},
  data() {
    return {
      showProfitIncrease: false,
      profitIncreaseCurrency: '',
      profitIncreasePartner: '',
      profitIncludeAmount: false,
      profitPartners: [],
      profitPreviewTimer: null,
      profitIncreasePoints: '',
      profitIncreaseBusy: false,
      profitIncreaseError: '',
      profitIncreaseResult: '',
      profitPreview: null,
      profitPreviewLoading: false,
      profitPreviewVersion: 0,
      profitBatches: [],
      profitProgress: { total: 0, processed: 0, updated: 0, skipped: 0, done: false },
      showQuickView: false,
      offerPercent: null,
      changePercent: null,
      changeRegularPercent: null,
      priceChangeBusy: false,
      priceChangeError: '',
      priceChangeResult: '',
      lastPriceRequest: null,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      products: [],
      totalProducts: 0,
      percentType: '',
      regularPercentType: '',
      currentPage: 1,
      itemsPerPage: 20,
      filters: {
        id_in: '',
        name_search: '',
        sku: '',
        search_value: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_in: null,
        brand_in: null,
        status_in: '',
        currency_in: null,
        supplier: null
      },
      categories: [],
      brands: [],
      currencies: []
    }
  },
  computed: {
    canChangeBasePrice() { return this.canSubmitPriceChange(this.regularPercentType, this.changeRegularPercent) },
    canChangeConsumerPrice() { return this.canSubmitPriceChange(this.percentType, this.changePercent) },
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
    publishedProducts() {
      return this.products.filter(p => p.status === 'publish').length
    },
    totalInventory() {
      return this.products.reduce((sum, product) => sum + product.calculate_current_inventory, 0)
    },
    averagePrice() {
      if (this.products.length === 0) return 0
      const sum = this.products.reduce((sum, product) => sum + product.price, 0)
      return Math.round(sum / this.products.length)
    }
  },
  methods: {
    openProfitIncrease() {
      if (!this.profitBatches.length) this.restoreProfitOperation();
      if (this.profitBatches.length) { this.showProfitIncrease = true; return; }
      this.profitPreview = null;
      this.profitProgress = { total: 0, processed: 0, updated: 0, skipped: 0, done: false };
      this.profitIncreaseCurrency = this.filters.currency_in || '';
      this.profitIncreasePoints = '';
      this.profitIncreasePartner = '';
      this.profitIncludeAmount = false;
      this.profitPartners = [];
      this.profitIncreaseError = '';
      this.profitIncreaseResult = '';
      this.showProfitIncrease = true;
      this.loadProfitPreview();
    },
    async submitProfitIncrease() {
      if (this.profitIncreaseBusy) return;
      const pointsText = String(this.profitIncreasePoints).trim()
        .replace(/[۰-۹]/g, digit => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
        .replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
      const points = Number(pointsText);
      if (!this.profitIncreaseCurrency || !/^[0-9]+$/.test(pointsText) || !Number.isSafeInteger(points) || points <= 0 || points > 2147483647) {
        this.profitIncreaseError = 'ارز را انتخاب کنید و مقدار افزایش را به صورت عدد صحیح مثبت وارد کنید.';
        return;
      }
      if (!this.profitBatches.length && (this.profitPreviewLoading || !this.profitPreview || Number(this.profitPreview.currency_id) !== Number(this.profitIncreaseCurrency) || this.profitPreview.percentage_points !== points)) return;
      if (!this.profitBatches.length) {
        const ids = this.profitPreview.product_ids;
        if (!ids.length) { this.profitIncreaseError = 'برای این انتخاب محصول واجد شرایطی وجود ندارد.'; return; }
        for (let index = 0; index < ids.length; index += 20) {
          const uuid = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, digit =>
            (Number(digit) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(digit) / 4).toString(16));
          this.profitBatches.push({ product_ids: ids.slice(index, index + 20), request_id: uuid,
            currency_id: Number(this.profitIncreaseCurrency), percentage_points: points,
            partner_id: this.profitIncreasePartner ? Number(this.profitIncreasePartner) : null, include_amount: this.profitIncludeAmount });
        }
        this.profitProgress = { total: ids.length, processed: 0, updated: 0, skipped: 0, done: false };
      }
      this.profitIncreaseBusy = true;
      this.profitIncreaseError = '';
      this.profitIncreaseResult = '';
      const headers = {};
      this.appendToken(headers);
      try {
        this.persistProfitOperation();
        while (this.profitBatches.length) {
          const batch = this.profitBatches[0];
          const response = await axios.request({ url: this.endpoint('product/increaseCurrencyProfitMargin'),
            method: 'post', headers, data: batch, timeout: 300000 });
          const data = response.data;
          this.profitProgress.processed += batch.product_ids.length;
          this.profitProgress.updated += data.updated_count;
          this.profitProgress.skipped += data.skipped_count;
          this.profitBatches.shift();
          this.persistProfitOperation();
        }
        this.profitProgress.done = true;
        this.profitIncreaseResult = `افزایش سود ${this.profitProgress.updated} محصول انجام شد؛ ${this.profitProgress.skipped} محصول به دلیل خارج شدن از شرایط کنار گذاشته شد.`;
        this.fetchProducts();
        this.loadProfitPreview();
      } catch (error) {
        const data = error.response && error.response.data;
        this.profitIncreaseError = data && (data.error || data.detail || data.percentage_points || data.currency_id) || (error.message && error.message.startsWith('ذخیره وضعیت') ? error.message : 'ارتباط قطع شد؛ با دکمه ادامه، دسته باقی‌مانده بدون افزایش تکراری ارسال می‌شود.');
      } finally { this.profitIncreaseBusy = false; }
    },
    loadProfitPreview() {
      clearTimeout(this.profitPreviewTimer);
      const version = ++this.profitPreviewVersion;
      this.profitPreview = null;
      this.profitIncreaseError = '';
      if (!this.profitIncreaseCurrency) { this.profitPreviewLoading = false; return; }
      const points = this.normalizedProfitPoints();
      if (points === null) { this.profitPreviewLoading = false; return; }
      this.profitPreviewLoading = true;
      this.request({ url: this.endpoint('product/previewCurrencyProfitMargin'), method: 'get',
        params: { currency_id: this.profitIncreaseCurrency, percentage_points: points,
          partner_id: this.profitIncreasePartner || undefined, include_amount: this.profitIncludeAmount },
        success: data => {
          if (version !== this.profitPreviewVersion) return;
          this.profitPreview = data;
          this.profitPartners = data.partners;
          this.profitPreviewLoading = false;
        },
        error: error => {
          if (version !== this.profitPreviewVersion) return;
          this.profitPreviewLoading = false;
          const data = error.response && error.response.data;
          this.profitIncreaseError = data && (data.error || data.detail) || 'دریافت نمونه محصولات انجام نشد.';
        },
      });
    },
    changeProfitCurrency() {
      this.profitIncreasePartner = '';
      this.profitPartners = [];
      this.loadProfitPreview();
    },
    normalizedProfitPoints() {
      const text = String(this.profitIncreasePoints).trim().replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d))).replace(/[٠-٩]/g, d => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));
      if (!text) return 1;
      const value = Number(text);
      return /^[0-9]+$/.test(text) && Number.isSafeInteger(value) && value > 0 && value <= 2147483647 ? value : null;
    },
    scheduleProfitPreview() {
      clearTimeout(this.profitPreviewTimer);
      this.profitPreviewVersion++;
      this.profitPreviewLoading = true;
      this.profitPreviewTimer = setTimeout(() => this.loadProfitPreview(), 350);
    },
    profitStorageKey() {
      return `profit-increase:${this.endpoint('')}:${this.user && this.user.id || 'current-user'}`;
    },
    persistProfitOperation() {
      if (!this.profitBatches.length) { localStorage.removeItem(this.profitStorageKey()); return; }
      try { localStorage.setItem(this.profitStorageKey(), JSON.stringify({ batches: this.profitBatches,
        progress: this.profitProgress, preview: this.profitPreview, partners: this.profitPartners,
        currency: this.profitIncreaseCurrency, partner: this.profitIncreasePartner,
        points: this.profitIncreasePoints, includeAmount: this.profitIncludeAmount }));
      } catch (error) { throw new Error('ذخیره وضعیت عملیات در مرورگر انجام نشد؛ فضای ذخیره مرورگر را بررسی کنید.'); }
    },
    restoreProfitOperation() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.profitStorageKey()) || 'null');
        if (!saved || !saved.batches || !saved.batches.length) return;
        this.profitBatches = saved.batches;
        this.profitProgress = saved.progress;
        this.profitPreview = saved.preview;
        this.profitPartners = saved.partners || [];
        this.profitIncreaseCurrency = saved.currency;
        this.profitIncreasePartner = saved.partner;
        this.profitIncreasePoints = saved.points;
        this.profitIncludeAmount = saved.includeAmount;
        this.profitIncreaseError = 'عملیات ناتمام بازیابی شد؛ برای ادامه از همان مرحله دکمه ادامه پردازش را بزنید.';
      } catch (error) { this.profitIncreaseError = 'بازیابی عملیات ناتمام انجام نشد.'; }
    },
    proposedProfit(margin) {
      const value = String(this.profitIncreasePoints).trim()
        .replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
        .replace(/[٠-٩]/g, d => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)));
      return /^[0-9]+$/.test(value) && Number(value) > 0 ? Number(margin) + Number(value) : '—';
    },

    showProductQuickView(product) {
      this.selectedProduct = product
      this.showQuickView = true
    },
    showProductQuickEdit(product) {
      this.selectedProductId = product.id
      this.showQuickEdit = true
    },
    handleEditProduct(product) {
      this.$router.push(`/panel/adminProductForm/${product.id}`)
    },
    goToExcelUpdate() {
      this.$router.push({name: 'DomesticPriceChangeExcelUpdate'})
    },
    fetchProducts() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      // Remove empty filters
      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('shop/adminProducts'),
        method: 'get',
        params,
        success: (data) => {
          this.products = data.results
          this.totalProducts = data.count
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    fetchCategories() {
      this.request({
        url: this.endpoint('api/rootCategories'),
        method: 'get',
        success: (data) => {
          this.categories = data
        }
      })
    },

    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },

    applyDiscount() {
      this.request({
        url: this.endpoint('product/ApplyOffer'),
        method: 'post',
        data: {
          offer_percent: this.offerPercent,
          brand_in: this.filters.brand_in,
          cat_in: this.filters.category_in,
          currency_in: this.filters.currency_in,
        },
        success: (data) => {
          this.fetchProducts()
        }
      })
    },
    validChangePercent(type, value) {
      const text = String(value == null ? '' : value).trim()
        .replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
        .replace(/[٠-٩]/g, d => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d))).replace('٫', '.')
      const percent = Number(text)
      return ['افزایش', 'کاهش'].includes(type) && /^\d+(\.\d{1,4})?$/.test(text) && Number.isFinite(percent)
        && percent > 0 && percent <= 100 && (type !== 'کاهش' || percent < 100) ? percent : null
    },
    canSubmitPriceChange(type, value) {
      return !this.priceChangeBusy && !!(this.filters.brand_in || this.filters.category_in || this.filters.currency_in)
        && this.validChangePercent(type, value) !== null
    },
    applyChange() { return this.submitPriceChange('regular_price', this.percentType, this.changePercent) },
    applyRegularChange() { return this.submitPriceChange('base_price', this.regularPercentType, this.changeRegularPercent) },
    async submitPriceChange(field, type, value) {
      if (!this.canSubmitPriceChange(type, value)) return
      const percent = this.validChangePercent(type, value)
      const payload = { brand_in: this.filters.brand_in, cat_in: this.filters.category_in, currency_in: this.filters.currency_in,
        increase_percent: type === 'افزایش' ? percent : null, decrease_percent: type === 'کاهش' ? percent : null }
      const signature = JSON.stringify({ field, payload })
      if (!this.lastPriceRequest || this.lastPriceRequest.signature !== signature) {
        const requestId = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, digit =>
          (Number(digit) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(digit) / 4).toString(16))
        this.lastPriceRequest = { signature, payload: { ...payload, request_id: requestId } }
      }
      this.priceChangeBusy = true; this.priceChangeError = ''; this.priceChangeResult = ''
      const headers = {}; this.appendToken(headers)
      try {
        const response = await axios.request({ url: this.endpoint(field === 'base_price' ? 'product/bulkBasePriceChange' : 'product/bulkRegularPriceChange'),
          method: 'post', headers, data: this.lastPriceRequest.payload, timeout: 300000 })
        this.priceChangeResult = response.data.message
        this.lastPriceRequest = null
        if (field === 'base_price') this.changeRegularPercent = null
        else this.changePercent = null
        this.fetchProducts()
      } catch (error) {
        const data = error.response && error.response.data
        const messages = value => typeof value === 'string' ? [value] : Array.isArray(value) ? value.flatMap(messages)
          : value && typeof value === 'object' ? Object.values(value).flatMap(messages) : []
        this.priceChangeError = messages(data).join(' ') || 'پاسخ سرور دریافت نشد؛ تکرار همین درخواست، درصد را دوباره اعمال نمی‌کند.'
      } finally { this.priceChangeBusy = false }
    },
    applyFilters() {
      this.currentPage = 1
      this.fetchProducts()
    },

    resetFilters() {
      this.filters = {
        search_value: '',
        id_in: '',
        sku: '',
        name_search: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        category_in: null,
        brand_in: null,
        currency_in: null
      }
      this.percentType = ''
      this.changePercent = null
      this.offerPercent = null
      this.regularPercentType = ''
      this.changeRegularPercent = null
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchProducts()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchProducts()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchProducts()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchProducts()
      }
    },

    getStatusLabel(status) {
      const statusMap = {
        'draft': 'پیش نویس',
        'pending': 'در انتظار تایید',
        'publish': 'منتشر شده',
      }
      if (!status) return ' '
      return statusMap[status] || status
    },
    getTypeLabel(type) {
      const typeMap = {
        'simple': 'ساده',
        'variable': 'دارای متغیر',
        'variation': 'متغیر',
      }
      if (!type) return ' '
      return typeMap[type] || type
    },

  },

  mounted() {
    for (let param in this.$route.query) {
      if(param == 'brand') {
        this.filters.brand_in = this.$route.query['brand']
      }
      if(param == 'currency') {
        this.filters.currency_in = this.$route.query['currency']

      }
      if(param == 'supplier') {
        this.filters.currency_in = this.$route.query['supplier']

      }
      if(param == 'currency') {
        this.filters.currency_in = this.$route.query['currency']

      }
    }

    this.fetchProducts()
    this.fetchBrands()
    this.fetchCategories()
    this.fetchCurrency()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px; /* or whatever width you need */
}

</style>
